module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingPromo/images/glowing.1636a64a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingPromo/images/glowing.png
// module id = 3139
// module chunks = 11